import React from 'react';
import { MdArrowDropDown, MdVisibility } from 'react-icons/md';
import { DropdownMenu } from 'ui';
import { UserMembersTranslation } from '../constants';
import { Visibility } from '../types-store';
import styles from './user-members-list-header-visibility.scss';

const shortLabel = {
  [Visibility.all]: (translation: UserMembersTranslation) => translation.visible_all,
  [Visibility.selected]: (translation: UserMembersTranslation) => translation.visible_selected,
  [Visibility.unselected]: (translation: UserMembersTranslation) => translation.visible_unselected
};

interface UserMembersListHeaderVisibilityProps {
  visiblity: Visibility;
  translation: UserMembersTranslation;
  showAll: () => void;
  showSelected: () => void;
  showUnSelected: () => void;
}

export const UserMembersListHeaderVisibility: React.FC<UserMembersListHeaderVisibilityProps> = ({
  visiblity, translation, showAll, showSelected, showUnSelected
}) => {

  const buttonNode = <div className={styles.hasMaxWidth}>
    <MdVisibility className={styles.visibilityIcon} />
    <span className={styles.visibilityLabel}>{shortLabel[visiblity](translation)}</span>
    <MdArrowDropDown className="dropdown-arrow" />
  </div>;

  return <DropdownMenu dropdownNode={buttonNode} closeAfterClick>
    <li>
      <button id="show-all" className="dropdown-item" type="button" onClick={showAll}>
        {translation.visible_show_all}
      </button>
    </li>
    <li>
      <button id="show-selected" className="dropdown-item" type="button" onClick={showSelected}>
        {translation.visible_show_selected}
      </button>
    </li>
    <li>
      <button id="show-unselected" className="dropdown-item" type="button" onClick={showUnSelected}>
        {translation.visible_show_unselected}
      </button>
    </li>
  </DropdownMenu>;
};
